import { Component, OnInit } from '@angular/core';
import { ReportConstants } from '../../models/report-parameters.model';

@Component({
  selector: 'lib-rt-shipment-car-situation-current-extended-report',
  templateUrl: './rt-shipment-car-situation-current-extended-report.component.html',
  styleUrls: ['./rt-shipment-car-situation-current-extended-report.component.css']
})
export class RtShipmentCarSituationCurrentExtendedReportComponent implements OnInit {

    public gridId = 102;
    public apiCall: string = ReportConstants.ReportDataApiCall;
    public pageHeader: string = 'Shipment Car Situation Current Extended Report';

    constructor() { }

    ngOnInit(): void {
    }

}